/** @jsxImportSource @emotion/react */
import { Text } from "@react-pdf/renderer";
import { DEFECT_POSITION, DEFECT_SEVERITY } from "../../../../actions/Checks/constants";
import { getFilledArrayOrDefault } from "../../../../utils";
import { DefectBadges } from "../../../Helper/Badges";
import { DefectBadgesVector } from "../../Helper/DefectBadgesVector";
import { DataSource } from "./Field";
import FruitField from "./FruitField";

export default class FruitDefectField extends FruitField {

    set_value({ fruit, tenantDefectDefinitions = [] }: DataSource): this {
        if (!fruit) {
            this.value = null;
            return this;
        }

        const filtered_defects = tenantDefectDefinitions.filter((i) => getFilledArrayOrDefault(this.field_config?.defect_position).includes(i.position as DEFECT_POSITION | string) && getFilledArrayOrDefault(this.field_config?.defect_severity).includes(i.severity as DEFECT_SEVERITY | string));

        const registered_defects = filtered_defects.filter((i) => {
            const registered_defect = getFilledArrayOrDefault(fruit.defects).find((j) => j.defect_id === i.defect_id);
            const frequency = registered_defect?.frequency || 0;
            return frequency > 0;
        });
        this.value = registered_defects.map((defect) => defect.label).join(",");
        return this;
    }

    display_component(): JSX.Element {
        if (!this.value) return <span>-</span>;
        return <DefectBadges defects={this.value as string} />;
    }

    display_vector(): JSX.Element {
        if (!this.value) return <Text>-</Text>;
        return <DefectBadgesVector defects={this.value as string} />;
    }
}
